import React from "react";

const LazyPages = {
  AddRole: React.lazy(() => import("../pages/RoleManageMent/AddRole/AddRole")),
  ContactSense: React.lazy(() => import("../pages/ContactSense/ContactSense")),
  LoginPage: React.lazy(() => import("../pages/LoginPage/LoginPage")),
  LayoutProtected: React.lazy(() => import("../layouts/LayoutProtected")),
  DashboardPage: React.lazy(
    () => import("../pages/DashboardPage/DashboardPage")
  ),
  Statement: React.lazy(() => import("../pages/Statement/Statement")),
  ForgotPassword: React.lazy(
    () => import("../pages/ForgotPassword/ForgotPassword")
  ),
  SettingsPage: React.lazy(() => import("../pages/SettingsPage/Settingspage")),
  PrivateOffice: React.lazy(() => import("../pages/TableOffice/Tableoffice")),
  ArchivedOffice: React.lazy(
    () => import("../pages/TableOffice/ArchivedOffice")
  ),
  OfficeView: React.lazy(() => import("../pages/OfficeView/OfficeView")),
  ProfessionalUser: React.lazy(
    () => import("../pages/ProfessionalTable/ProfessionalTable")
  ),
  ProfessionalView: React.lazy(
    () => import("../pages/ProfessionalView/ProfessionalView")
  ),
  RoleManagement: React.lazy(
    () => import("../pages/RoleManageMent/RoleManagement")
  ),
  Notes: React.lazy(() => import("../pages/Notes/Notes")),
  JobView: React.lazy(() => import("../pages/JobView/JobView")),
  Calander: React.lazy(() => import("../pages/Calander/Calander")),
  Category: React.lazy(
    () => import("../pages/CategoryManagement/CategoryManagement")
  ),
  Notification: React.lazy(
    () => import("../pages/NotificationManagement/NotificationManagement")
  ),
  PayRangeAndBills: React.lazy(
    () => import("../pages/PayRangeAndBills/PayRangeAndBills")
  ),
  EditJob: React.lazy(() => import("../pages/Jobs/AddJob/PostJob")),
  PostJob: React.lazy(() => import("../pages/Jobs/AddJob/PostJob")),
  Reports: React.lazy(() => import("../pages/Reports/Reports")),
  RevenueReports: React.lazy(
    () => import("../pages/RevenueReport/RevenueReport")
  ),
  RevenueReportsDetails: React.lazy(
    () => import("../pages/RevenueReportDetail/RevenueReportDetail")
  ),
  ResetPassword: React.lazy(
    () => import("../pages/ResetPassword/ResetPassword")
  ),
  Jobs: React.lazy(() => import("../pages/Jobs/Jobs")),
  JobsAssignments: React.lazy(
    () => import("../pages/JobAssignments/JobAssignments")
  ),
  JobsAssignmentsDetails: React.lazy(
    () => import("../pages/JobAssignments/RecruiterDetails/RecruiterDetails")
  ),
  JobsCancelled: React.lazy(
    () => import("../pages/JobsCancelled/JobCancelled")
  ),
  Timesheet: React.lazy(
    () => import("../pages/TimesheetManagement/TimesheetManagement")
  ),
  TimesheetProfessional: React.lazy(
    () =>
      import("../pages/TimesheetManagement/ProfessionalTimesheet/ProfessionalTimesheet")
  ),
  TimesheetView: React.lazy(
    () => import("../pages/TimesheetManagement/ViewTimesheet/ViewTimesheet")
  ),
  ViewRole: React.lazy(
    () => import("../pages/RoleManageMent/ViewRole/ViewRole")
  ),
  Prospects: React.lazy(() => import("../pages/Prospects/Prospects")),
  ProspectImportLog: React.lazy(
    () => import("../pages/Prospects/ImportLog/ImportLog")
  ),
  AddProspects: React.lazy(
    () => import("../pages/Prospects/AddProspect/AddProspect")
  ),
  ProspectView: React.lazy(
    () => import("../pages/Prospects/ProspectView/ProspectView")
  ),
  AddPayRangeBillRate: React.lazy(
    () => import("../pages/AddPayRangeBillRate/AddPayRangeBillRate")
  ),
  Invoice: React.lazy(() => import("../pages/Invoice/Invoice")),
  MasterInvoice: React.lazy(
    () => import("../pages/Invoice/MasterInvoice/MasterInvoice")
  ),
  OnAccount: React.lazy(() => import("../pages/OnAccount/OnAccount")),
  OnAccountDetails: React.lazy(
    () => import("../pages/OnAccount/OnAccountDetails/OnAccountDetails")
  ),
  CreditMemo: React.lazy(() => import("../pages/CreditMemo/CreditMemo")),
  CreditMemoDetails: React.lazy(
    () => import("../pages/CreditMemo/CreditMemoDetails/CreditMemoDetails")
  ),
  InvoiceDetails: React.lazy(
    () => import("../pages/Invoice/InvoiceDetails/InvoiceDetails")
  ),
  InvoiceJobInfo: React.lazy(
    () => import("../pages/Invoice/InvoiceDetails/JobInfo/JobInfo")
  ),
  InvoiceTimesheetInfo: React.lazy(
    () => import("../pages/Invoice/InvoiceDetails/TimesheetInfo/TimesheetInfo")
  ),
  TimesheetJobDetails: React.lazy(
    () =>
      import("../pages/TimesheetManagement/TimesheetPayment/JobDetailsTable/JobDetailsTable")
  ),
  TimesheetDetails: React.lazy(
    () =>
      import("../pages/TimesheetManagement/TimesheetPayment/TimesheetDetails/TimesheetDetails")
  ),
  ManualInvoiceReport: React.lazy(
    () => import("../pages/ManualInvoiceReport/ManualInvoiceReport")
  ),
  Referral: React.lazy(
    () => import("../pages/ReferralManagement/ReferralManagement")
  ),
  SubReferralManagement: React.lazy(
    () => import("../pages/ReferralManagement/SubReferralManagement")
  ),
  PayScaleOffices: React.lazy(
    () => import("../pages/PayScaleOffices/PayScaleOffices")
  ),
  TransparencyModel: React.lazy(
    () => import("../pages/TransparencyModel/TransparencyModel")
  ),
  AddTransparencyPayScale: React.lazy(
    () => import("../pages/TransparencyModel/AddTransparencyPayScale")
  ),
  ReferralJob: React.lazy(() => import("../pages/ReferralJob/ReferralJob")),
};

export default LazyPages;
